(function () {
  var titleMap = {
    "Para iade politikası": "PARA İADE POLİTİKASI",
    "Kargo politikası": "Ödeme ve Teslimat",
    "Gizlilik Politikası": "Gizlilik ve Güvenlik Politikası",
    "İletişim bilgileri": "Firma Bilgileri",
  };
  var el = document.querySelector(".shopify-policy__title h1");
  if (el) {
    var replacement = titleMap[el.textContent.trim()];
    if (replacement) el.textContent = replacement;
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  // Capture phase'de yakala - event bubbling'den önce çalışır
  document.body.addEventListener(
    "click",
    function (e) {
      var clickedEl = e.target;

      // Tıklanan element bir <a> mı veya <a> içinde mi kontrol et
      var link = clickedEl.closest("a");

      if (link && link.closest("label")) {
        // Label içindeki bir linke tıklandı
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Linki manuel aç
        var href = link.getAttribute("href");
        if (href && href !== "#") {
          if (link.getAttribute("target") === "_blank") {
            window.open(href, "_blank");
          } else {
            window.location.href = href;
          }
        }
      }
    },
    true,
  ); // true = capture phase
});

document.addEventListener("DOMContentLoaded", function () {
  var links = document.querySelectorAll("label a");

  links.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();

      var href = this.getAttribute("href");
      if (href && href !== "#") {
        if (this.getAttribute("target") === "_blank") {
          window.open(href, "_blank");
        } else {
          window.location.href = href;
        }
      }
    });
  });
});

(function () {
  function updateButton(wrap) {
    const content = wrap.querySelector("[data-rt-content]");
    const btn = wrap.querySelector("[data-rt-btn]");
    if (!content || !btn) return;

    // Kapalı moda alıp ölç (açıkken zaten her şey görünür)
    const wasOpen = wrap.classList.contains("is-open");
    if (wasOpen) wrap.classList.remove("is-open");

    // CSS'ten max-height'i okuyup taşma var mı kontrol et
    const maxH = parseFloat(getComputedStyle(content).maxHeight || "0");
    const fullH = content.scrollHeight;

    const shouldShow = fullH > maxH + 1; // 1px tolerans
    btn.hidden = !shouldShow;

    // Metin
    btn.textContent = wasOpen ? "Kapat" : "Tümünü Gör";

    // Eski state'i geri koy
    if (wasOpen) wrap.classList.add("is-open");
  }

  function initRichTextToggles(root = document) {
    root.querySelectorAll("[data-rt-toggle]").forEach((wrap) => {
      if (wrap.dataset.inited === "1") return;
      if (wrap.dataset.rtReadMore === "false") return;
      wrap.dataset.inited = "1";

      const btn = wrap.querySelector("[data-rt-btn]");
      if (!btn) return;

      // İlk ölçümler (theme editor + font load gecikmeleri için)
      requestAnimationFrame(() => updateButton(wrap));
      setTimeout(() => updateButton(wrap), 150);
      setTimeout(() => updateButton(wrap), 600);

      btn.addEventListener("click", () => {
        const isOpen = wrap.classList.toggle("is-open");
        btn.textContent = isOpen ? "Kapat" : "Tümünü Gör";
      });

      window.addEventListener("resize", () => updateButton(wrap));
    });
  }

  document.addEventListener("DOMContentLoaded", () => initRichTextToggles());
  document.addEventListener("shopify:section:load", (e) =>
    initRichTextToggles(e.target),
  );
})();

(function () {
  function digitsOnly(str) {
    return (str || "").replace(/\D/g, "");
  }

  function formatPhoneE164(d) {
    if (!d) return "";
    if (d.length === 10) return "+90" + d;
    if (d.length === 11 && d.charAt(0) === "0") return "+90" + d.slice(1);
    if (d.length >= 11 && d.slice(0, 2) === "90") return "+" + d;
    return "+" + d;
  }

  function showClientError(el, msg) {
    if (!el) return;
    el.textContent = msg || "";
    el.classList.toggle("hidden", !msg);
  }

  function removeDynamicMarketingFields(form) {
    form
      .querySelectorAll('input[name="contact[accepts_marketing]"]')
      .forEach((n) => n.remove());
    form
      .querySelectorAll('input[name^="contact[sms_marketing_consent]"]')
      .forEach((n) => n.remove());
    form
      .querySelectorAll("input[data-nodus-popup-sync]")
      .forEach((n) => n.remove());
  }

  function appendHiddenSync(form, name, value) {
    const h = document.createElement("input");
    h.type = "hidden";
    h.name = name;
    h.value = value;
    h.setAttribute("data-nodus-popup-sync", "");
    form.appendChild(h);
  }

  function appendSmsMarketingConsentFields(form) {
    const ts = new Date().toISOString();
    const pairs = [
      ["state", "subscribed"],
      ["opt_in_level", "single_opt_in"],
      ["consent_collected_from", "SHOPIFY"],
      ["consent_updated_at", ts],
    ];
    for (let p = 0; p < pairs.length; p++) {
      const c = document.createElement("input");
      c.type = "hidden";
      c.name = "contact[sms_marketing_consent][" + pairs[p][0] + "]";
      c.value = pairs[p][1];
      form.appendChild(c);
    }
  }

  function bindPopupNewsletterForm(form) {
    if (form.dataset.nodusPopupNewsletterBound === "true") return;
    form.dataset.nodusPopupNewsletterBound = "true";

    const inner = form.querySelector(".newsletter-form__inner");
    const phoneInput = form.querySelector(".nodus-popup-newsletter-phone");
    const emailInput = form.querySelector(".nodus-popup-newsletter-email");
    const cbLegal = form.querySelector(".nodus-popup-consent-legal");
    const cbEmail = form.querySelector(".nodus-popup-consent-email");
    const cbSms = form.querySelector(".nodus-popup-consent-sms");
    const cbCall = form.querySelector(".nodus-popup-consent-call");
    const tagsInput = form.querySelector('[id^="PopupNewsletterTags--"]');
    const submitBtn = form.querySelector(
      'button[type="submit"], input[type="submit"]',
    );
    const clientErr = form.querySelector(
      ".nodus-popup-newsletter-client-error",
    );

    let submitting = false;

    if (phoneInput) {
      phoneInput.addEventListener("input", function () {
        phoneInput.value = digitsOnly(phoneInput.value);
      });
      phoneInput.addEventListener("paste", function (e) {
        e.preventDefault();
        const t =
          (e.clipboardData || window.clipboardData).getData("text") || "";
        phoneInput.value = digitsOnly(phoneInput.value + t);
      });
    }

    function submitPopupNewsletter() {
      if (submitting || !inner) return;

      const msgNeed = inner.getAttribute("data-msg-need-contact");
      const msgLegal = inner.getAttribute("data-msg-legal-consent");
      const msgEmail = inner.getAttribute("data-msg-email-consent");
      const msgSms = inner.getAttribute("data-msg-sms-consent");
      const msgEmailNeeds = inner.getAttribute("data-msg-email-needs");
      const msgSmsNeeds = inner.getAttribute("data-msg-sms-needs-phone");

      const emailVal = (emailInput && emailInput.value.trim()) || "";
      const phoneDigits = phoneInput ? digitsOnly(phoneInput.value) : "";

      showClientError(clientErr, "");

      if (!emailVal && !phoneDigits) {
        showClientError(clientErr, msgNeed);
        return;
      }

      if (!cbLegal || !cbLegal.checked) {
        showClientError(clientErr, msgLegal);
        return;
      }

      if (emailVal && cbEmail && !cbEmail.checked) {
        showClientError(clientErr, msgEmail);
        return;
      }

      if (phoneDigits && cbSms && !cbSms.checked) {
        showClientError(clientErr, msgSms);
        return;
      }

      if (cbEmail && cbEmail.checked && !emailVal) {
        showClientError(clientErr, msgEmailNeeds);
        return;
      }

      if (
        (cbSms && cbSms.checked && !phoneDigits) ||
        (cbCall && cbCall.checked && !phoneDigits)
      ) {
        showClientError(clientErr, msgSmsNeeds);
        return;
      }

      removeDynamicMarketingFields(form);

      const am = document.createElement("input");
      am.type = "hidden";
      am.name = "contact[accepts_marketing]";
      am.value = cbEmail && cbEmail.checked ? "true" : "false";
      form.appendChild(am);

      if (cbSms && cbSms.checked && phoneDigits) {
        appendSmsMarketingConsentFields(form);
      }

      let tags = "newsletter";
      if (cbCall && cbCall.checked) tags += ", arama-izni";
      if (cbSms && cbSms.checked && phoneDigits) tags += ", sms-mkt-subscribed";
      if (tagsInput) tagsInput.value = tags;

      if (phoneInput) {
        if (phoneDigits) {
          const formattedPhone = formatPhoneE164(phoneDigits);
          const phoneTagSuffix = formattedPhone.replace(/\D/g, "");
          if (phoneTagSuffix) {
            tags += ", nodus-tel-" + phoneTagSuffix;
            if (tagsInput) tagsInput.value = tags;
          }

          phoneInput.disabled = false;
          phoneInput.setAttribute("name", "contact[phone]");
          phoneInput.value = formattedPhone;

          appendHiddenSync(
            form,
            "contact[note]",
            (inner.getAttribute("data-phone-note-prefix") || "Tel") +
              ": " +
              formattedPhone,
          );

          appendHiddenSync(form, "customer[phone]", formattedPhone);
        } else {
          phoneInput.removeAttribute("name");
          phoneInput.value = "";
        }
      }

      submitting = true;
      form.submit();
    }

    // KVKK app'i (CompliTR) form_type=customer olan her formun uzerine capture
    // fazinda bir submit dinleyicisi birakiyor ve kendi onay kutusu isaretli
    // degilse stopImmediatePropagation() ile olayi kesiyor. Popup'ta o kutuyu
    // sonradan DOM'dan siliyor ama dinleyici formda kaliyor; bu yuzden submit
    // olayi bize hic ulasmiyordu. Gonderimi butonun click'ine baglayip
    // form.submit() ile yolluyoruz: form.submit() submit olayi uretmedigi icin
    // o dinleyici devreye girmiyor.
    if (submitBtn) {
      submitBtn.addEventListener("click", function (e) {
        e.preventDefault();
        submitPopupNewsletter();
      });
    }

    form.addEventListener(
      "submit",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitPopupNewsletter();
      },
      true,
    );
  }

  function initPopupNewsletter(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll("form.nodus-popup-newsletter-form")
      .forEach(bindPopupNewsletterForm);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initPopupNewsletter(document);
  });
  document.addEventListener("shopify:section:load", function (ev) {
    initPopupNewsletter(ev.target);
  });
})();

// ===== Footer Consent Modals =====
(function () {
  var currentTrigger = null;
  var dynamicModalCache = {};
  var dynamicModalId = "footer-dynamic-consent-modal";

  function getDynamicModal() {
    var modal = document.getElementById(dynamicModalId);
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = dynamicModalId;
    modal.className = "footer-consent-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-labelledby", dynamicModalId + "-title");
    modal.setAttribute("hidden", "");
    modal.innerHTML =
      '<div class="footer-consent-modal__overlay" data-modal-close aria-hidden="true"></div>' +
      '<div class="footer-consent-modal__panel">' +
      '<h2 class="footer-consent-modal__title" id="' +
      dynamicModalId +
      '-title"></h2>' +
      '<div class="footer-consent-modal__content"></div>' +
      '<div class="footer-consent-modal__footer">' +
      '<button type="button" class="footer-consent-modal__accept button button--primary" data-modal-accept>Okudum, anladım</button>' +
      "</div>" +
      "</div>";
    document.body.appendChild(modal);
    return modal;
  }

  function setModalCheckboxName(modal, checkboxName) {
    var acceptButton = modal.querySelector("[data-modal-accept]");
    if (!acceptButton) return;
    if (checkboxName) {
      acceptButton.setAttribute("data-checkbox-name", checkboxName);
    } else {
      acceptButton.removeAttribute("data-checkbox-name");
    }
  }

  function getCheckboxNameFromContext(node) {
    if (!node || !node.closest) return "";
    var agreementLabel = node.closest(".cart__agreement-label");
    if (!agreementLabel) return "";

    var checkbox = agreementLabel.querySelector(
      ".cart__agreement-checkbox[name]",
    );
    if (!checkbox) return "";

    return checkbox.getAttribute("name") || "";
  }

  function toSameOriginUrl(href) {
    if (!href) return null;
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      return url;
    } catch (_err) {
      return null;
    }
  }

  function extractPagePayload(htmlText, fallbackUrl) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlText, "text/html");
    var titleEl = doc.querySelector("main h1, h1, title");
    var title = titleEl ? titleEl.textContent.trim() : "Bilgilendirme Metni";
    var contentRoot =
      doc.querySelector("main .shopify-policy__body") ||
      doc.querySelector("main .rte") ||
      doc.querySelector(".main-page-content") ||
      doc.querySelector("[data-page-content]") ||
      doc.querySelector("main");

    var html = "";
    if (contentRoot && contentRoot.innerHTML.trim() !== "") {
      html = contentRoot.innerHTML;
    } else {
      html =
        '<p>Icerik yuklenemedi. Lutfen <a href="' +
        fallbackUrl +
        '" target="_blank" rel="noopener">sayfayi ziyaret edin</a>.</p>';
    }

    return {
      title: title,
      html: html,
    };
  }

  function renderDynamicModal(modal, payload) {
    var titleEl = modal.querySelector(".footer-consent-modal__title");
    var contentEl = modal.querySelector(".footer-consent-modal__content");
    if (titleEl) titleEl.textContent = payload.title || "Bilgilendirme Metni";
    if (contentEl) contentEl.innerHTML = payload.html || "";
  }

  function openDynamicModalFromUrl(url, trigger, checkboxName) {
    var modal = getDynamicModal();
    var cacheKey = url.pathname + url.search;
    var loadingPayload = {
      title: "Bilgilendirme Metni",
      html: "<p>Icerik yukleniyor...</p>",
    };

    currentTrigger = trigger;
    setModalCheckboxName(modal, checkboxName || "");

    if (dynamicModalCache[cacheKey]) {
      renderDynamicModal(modal, dynamicModalCache[cacheKey]);
      openModal(modal);
      return;
    }

    renderDynamicModal(modal, loadingPayload);
    openModal(modal);

    fetch(url.toString(), { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.text();
      })
      .then(function (htmlText) {
        var payload = extractPagePayload(htmlText, url.toString());
        dynamicModalCache[cacheKey] = payload;
        renderDynamicModal(modal, payload);
      })
      .catch(function () {
        renderDynamicModal(modal, {
          title: "Bilgilendirme Metni",
          html:
            '<p>Icerik yuklenemedi. Lutfen <a href="' +
            url.toString() +
            '" target="_blank" rel="noopener">sayfayi ziyaret edin</a>.</p>',
        });
      });
  }

  function openStaticModalById(modalId, trigger) {
    if (!modalId) return false;
    var modal = document.getElementById(modalId);
    if (!modal) return false;
    currentTrigger = trigger;
    openModal(modal);
    return true;
  }

  function handleAgreementClick(target, event) {
    var agreementLabel = target.closest(".cart__agreement-label");
    if (!agreementLabel || target.closest("a, button")) return false;

    var checkbox = agreementLabel.querySelector(".cart__agreement-checkbox");
    if (!checkbox) return false;

    var staticModalId = checkbox.getAttribute("data-modal-target");
    if (staticModalId) {
      event.preventDefault();
      return openStaticModalById(staticModalId, checkbox);
    }

    var linkedNode = agreementLabel.querySelector(
      ".cart__agreement-text a[href]",
    );
    if (!linkedNode) return false;

    var targetUrl = toSameOriginUrl(linkedNode.getAttribute("href"));
    if (!targetUrl) return false;

    event.preventDefault();
    openDynamicModalFromUrl(
      targetUrl,
      checkbox,
      checkbox.getAttribute("name") || "",
    );
    return true;
  }

  function openModal(modal) {
    modal.removeAttribute("hidden");
    document.body.classList.add("footer-modal-open");
    var panel = modal.querySelector(".footer-consent-modal__panel");
    if (panel) {
      panel.setAttribute("tabindex", "-1");
      panel.focus();
    }
  }

  function closeModal(modal) {
    modal.setAttribute("hidden", "");
    document.body.classList.remove("footer-modal-open");
    if (currentTrigger) {
      currentTrigger.focus();
      currentTrigger = null;
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
      // Trigger: open modal
      var trigger = e.target.closest(".footer-modal__trigger");
      if (trigger) {
        var modalId = trigger.getAttribute("data-modal-target");
        if (modalId) {
          e.preventDefault();
          openStaticModalById(modalId, trigger);
          return;
        }

        var triggerUrl = toSameOriginUrl(trigger.getAttribute("href"));
        if (triggerUrl) {
          e.preventDefault();
          openDynamicModalFromUrl(
            triggerUrl,
            trigger,
            getCheckboxNameFromContext(trigger),
          );
          return;
        }
      }

      var dynamicLink = e.target.closest(
        ".cart__agreement-text a[href], .contact-form__add-text a[href], .newsletter__additional-text a[href]",
      );
      if (dynamicLink) {
        var dynamicUrl = toSameOriginUrl(dynamicLink.getAttribute("href"));
        if (dynamicUrl) {
          e.preventDefault();
          openDynamicModalFromUrl(
            dynamicUrl,
            dynamicLink,
            getCheckboxNameFromContext(dynamicLink),
          );
          return;
        }
      }

      if (handleAgreementClick(e.target, e)) return;

      // Overlay: close modal
      if (e.target.hasAttribute("data-modal-close")) {
        var overlayModal = e.target.closest(".footer-consent-modal");
        if (overlayModal) closeModal(overlayModal);
        return;
      }

      // Accept button: check checkbox + close
      var acceptBtn = e.target.closest("[data-modal-accept]");
      if (acceptBtn) {
        var acceptModal = acceptBtn.closest(".footer-consent-modal");
        if (acceptModal) {
          var cbName = acceptBtn.getAttribute("data-checkbox-name");
          if (cbName) {
            var cb = null;
            if (currentTrigger && currentTrigger.closest) {
              var triggerForm = currentTrigger.closest("form");
              if (triggerForm) {
                cb = triggerForm.querySelector('input[name="' + cbName + '"]');
              }
            }
            if (!cb)
              cb = document.querySelector('input[name="' + cbName + '"]');
            if (cb && !cb.checked) {
              cb.checked = true;
              cb.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
          closeModal(acceptModal);
        }
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        var openedModal = document.querySelector(
          ".footer-consent-modal:not([hidden])",
        );
        if (openedModal) closeModal(openedModal);
      }
    });
  });
})();

/* Header arama (.header__search--expand): acilan alanin sag kenarini arama ikonuna hizalar
   ve acilista .is-expanded ekleyerek width transition'ini (sagdan sola) baslatir.
   Desktop'ta alan .header__search'e, mobilde .header'a gore konumlanir (bkz. nodus.css). */
(function () {
  const mobile = window.matchMedia("(max-width: 989px)");

  function setSearchOffset(modal) {
    const summary = modal.querySelector(":scope > details > summary");
    const container = mobile.matches ? modal.closest(".header") : modal;
    if (!summary || !container) return;

    const offset =
      container.getBoundingClientRect().right -
      summary.getBoundingClientRect().right;
    modal.style.setProperty("--nodus-search-offset", `${offset}px`);
  }

  // Capture: details-modal acilmadan once offset hazir olsun, animasyon dogru noktadan baslasin.
  document.addEventListener(
    "click",
    (e) => {
      const modal = e.target.closest(".header__search--expand");
      if (modal && e.target.closest("summary")) setSearchOffset(modal);
    },
    true,
  );

  // toggle bubble etmez; capture ile document'ta yakalanir.
  document.addEventListener(
    "toggle",
    (e) => {
      const details = e.target;
      const modal = details.parentElement;
      if (!modal || !modal.classList.contains("header__search--expand")) return;

      if (!details.open) {
        modal.classList.remove("is-expanded");
        return;
      }

      setSearchOffset(modal);
      // Iki frame: ikon genisligindeki baslangic durumu cizilsin, sonra transition calissin.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (details.open) modal.classList.add("is-expanded");
        });
      });
    },
    true,
  );

  window.addEventListener("resize", () => {
    document
      .querySelectorAll(".header__search--expand")
      .forEach((modal) => {
        if (modal.querySelector("details[open]")) setSearchOffset(modal);
      });
  });
})();
